import React from 'react'

const SvgNike = props => (
  <svg viewBox='0 0 126.76 45.18' {...props}>
    <path d='M14 45.16a15.5 15.5 0 0 1-9.28-3.1 19.53 19.53 0 0 1-1.93-1.93 12.3 12.3 0 0 1-2.11-3.77C-.69 32.27 0 26.9 2.69 21c2.31-5 5.83-10.06 12-17 .91-1 3.61-4 3.63-4s-.14.26-.33.57a36.47 36.47 0 0 0-3.72 8.59c-1.2 4.39-1.06 8.17.42 11.09A10.91 10.91 0 0 0 19.44 25c3.44 1.69 8.49 1.83 14.65.41.42-.1 21.45-5.68 46.72-12.41l46-12.21-89.24 38.15c-4.83 2.06-6.12 2.58-8.39 3.38-5.8 2.03-11 3.01-15.18 2.84z' />
  </svg>
)

export default SvgNike



// WEBPACK FOOTER //
// ./components/icons/experts/Nike.js